function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.282 15.75c-.7 0-1.282.598-1.282 1.31 0 .714.583 1.31 1.282 1.31.67 0 1.28-.596 1.25-1.278.03-.75-.548-1.342-1.25-1.342m-.294-9.713c-.61.178-.988.745-.988 1.43.03.414.056.833.087 1.246.086 1.579.174 3.123.26 4.7.032.535.436.922.96.922.523 0 .931-.413.956-.952 0-.325 0-.625.033-.953.055-1.012.117-2.024.173-3.035.032-.653.087-1.31.118-1.963 0-.237-.031-.446-.117-.655a1.278 1.278 0 0 0-1.482-.74" /></svg>;
});


// WEBPACK FOOTER //
// ./src/components/Icon/icons/bang.icon.svg